import { CoreMobiResource } from '@bepatient/core';

/**
 * Objet de base d'une catégorie
 */
export interface Category {
  /**
   * Couleur de la catégorie
   */
  color: string;
  /**
   * Titre de la catégorie
   */
  title: string;
  /**
   * Image de la catégorie
   */
  image: string;
  /**
   * Un tableau des objets contenus dans la catégorie, voir {@link CategoryItem}
   */
  items: Array<CategoryItem>;
  /**
   * Category Icon
   */
  icon?: string;
}

/**
 * Objet contenu dans une catégorie
 */
export interface CategoryItem {
  /**
   * Couleur de l'objet
   */
  color: string;
  /**
   * Titre de l'objet
   */
  title: string;
  /**
   * Image de l'objet
   */
  image: string;
  /**
   * Activity containing progress status
   */
  progress: number;
  /**
   * Resource de l'object, voir {@link CoreMobiResource} dans `CoreModule`
   */
  resource?: CoreMobiResource;
  /**
   * Contenu HTML d'un item HTML
   */
  htmlContent?: string;
  /**
   * Category Item Icon
   */
  icon?: string;
}
